import { useApi } from 'data/base-api';
import { postPublic } from 'libs/apiClient';
import type { ExternalTrainingConfirmationViewModel } from 'model/ExternalTrainingConfirmation/types';

// Public (no-login) endpoints on the timestyr API, authorized by the xai/xat access token in the link
// (same scheme as alerts / info-messages). Rendered under PublicRoot, so `useApi` uses the `getPublic` fetcher.
const externalConfirmBaseUrl = '/api/equipment-training/external-confirm';

export const useGetExternalTrainingConfirmation = (
  trainingId: string | undefined,
  xai: string | undefined,
  xat: string | undefined
) => {
  const params = new URLSearchParams();
  if (xai) params.set('xai', xai);
  if (xat) params.set('xat', xat);

  const { data, ...rest } = useApi<ExternalTrainingConfirmationViewModel>(
    trainingId && xai && xat
      ? `${externalConfirmBaseUrl}/${trainingId}?${params}`
      : null
  );

  return {
    confirmation: data,
    ...rest,
  };
};

export const useRespondToExternalTraining = () => {
  const respond = async (
    trainingId: string,
    action: 'confirm' | 'decline',
    xai: string,
    xat: string
  ): Promise<ExternalTrainingConfirmationViewModel> => {
    const params = new URLSearchParams({ xai, xat });
    const response = await postPublic(
      `${externalConfirmBaseUrl}/${trainingId}/${action}?${params}`
    );

    return response.json();
  };

  return respond;
};
